// Seed data mirroring the categories shown in the customer-facing app.
// Shared by Categories Management and the Dashboard. No backend endpoint exists yet.
const INITIAL_CATEGORIES = [
  { id: 1, name: "Cars", imageUrl: "" },
  { id: 2, name: "Vans & Buses", imageUrl: "" },
  { id: 3, name: "Trucks & Trailers", imageUrl: "" },
  { id: 4, name: "Earth-Moving", imageUrl: "" },
  { id: 5, name: "Motorbikes", imageUrl: "" },
  { id: 6, name: "Auto Parts", imageUrl: "" },
  { id: 7, name: "Auto Services", imageUrl: "" },
  { id: 8, name: "Boats", imageUrl: "" },
];

export default INITIAL_CATEGORIES;
